import { api } from "@/redux/api";

import { RequestPaginationParams } from "@/types/request-params";

import {
	Companies,
	CompaniesResponse,
	CompaniesResponseSchema,
	CompaniesSchema,
	CreateCompanies,
	TopupCompany,
} from "../../pages/Companies/schema/companies";

export const companiesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCompanies: builder.query<CompaniesResponse, RequestPaginationParams>({
			query: ({ sorting, ...params }) => ({
				url: "company",
				params: {
					...(params && { ...params }),
					...(sorting && { ...sorting }),
				},
				responseSchema: CompaniesResponseSchema,
			}),
			providesTags: ["Companies"],
		}),
		getCompany: builder.query<Companies, number>({
			query: (id: number) => ({
				url: `company/${id}`,
				params: {
					id,
				},
				responseSchema: CompaniesSchema,
			}),
			providesTags: ["Companies"],
		}),
		createCompanies: builder.mutation<Partial<Companies>, CreateCompanies>({
			query: (body) => ({
				url: `company`,
				method: "POST",
				body,
				responseSchema: CompaniesSchema,
			}),
			invalidatesTags: ["Companies"],
		}),
		updateCompanies: builder.mutation<Partial<Companies>, Partial<Companies>>({
			query: ({ id, ...body }) => ({
				url: `company/${id}`,
				method: "PATCH",
				body,
				responseSchema: CompaniesSchema,
			}),
			invalidatesTags: ["Companies"],
		}),
		topupCompany: builder.mutation<Partial<Companies>, TopupCompany>({
			query: ({ id, ...body }) => ({
				url: `company/topup/${id}`,
				method: "PATCH",
				body,
				responseSchema: CompaniesSchema,
			}),
			invalidatesTags: ["Companies"],
		}),
		deleteCompanies: builder.mutation<Partial<Companies>, number>({
			query: (id) => ({
				url: `company/${id}`,
				method: "DELETE",
				responseSchema: CompaniesSchema,
			}),
			invalidatesTags: ["Companies"],
		}),
	}),
});

export const {
	useGetCompaniesQuery,
	useLazyGetCompaniesQuery,
	useGetCompanyQuery,
	useLazyGetCompanyQuery,
	useUpdateCompaniesMutation,
	useDeleteCompaniesMutation,
	useCreateCompaniesMutation,
	useTopupCompanyMutation,
} = companiesApi;
export const accountApiReducer = companiesApi.reducer;
export const accountApiMiddleware = companiesApi.middleware;
